/* Warehouses Store */

import {fetchWarehouses} from '@/api'

const state = {
    warehouses: []
}

const actions = {
    fetchWarehouses (context, params) {
        return fetchWarehouses(params).then(r => {
            context.commit('setWarehouses', r.data)
        })
    }
}

const mutations = {
    setWarehouses (state, payload) {
        state.warehouses = payload
    }
}

const getters = {
    getWarehouses (state) {
        return state.warehouses
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
